module.exports = __webpack_public_path__ + "img/activities-3.678bd419.jpg";